import {
  GET_STORY_STATISTICS,
  GET_STORY_STATISTICS_SUCCESS,
} from "../../actions/statistics/types";

const initialState = {
  storyStatisticsLoading: false,
  storyStatisticsData: {values:[],labels:[]},
};

export const stories = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_STORY_STATISTICS:
      return {
        ...state,
        storyStatisticsLoading: true,
      };
    case GET_STORY_STATISTICS_SUCCESS:
      return {
        ...state,
        storyStatisticsLoading: false,
        storyStatisticsData: payload,
      };

    default: {
      return state;
    }
  }
};
